<h2 class="mb-5">{{'COMMON.REPORTS' | translate | titlecase}}</h2>

<ng-container *ngIf="candidate">
  <div class="row mb-4">
    <div class="col-6">
      <div class="btn btn-primary backToHistoricButton" (click)="utilsService.goBack(); utilsService.setLastUrl()">
        <i class="fa fa-arrow-left" style="font-size: 15px;"></i> {{ ('COMMON.BACK' | translate).toUpperCase() }}
      </div>
    </div>
  </div>

  <div class="card mb-4 border-0 shadow-sm">
    <div class="card-body">
      {{'COMMON.CANDIDATE' |translate}}:
      <div class="row">
        <div class="col-4">{{ candidate?.name ?  ((  candidate.name  + ' ' + candidate.surnameComplete) | titlecase ) : candidate.randstadCandidate  }}</div>
        <div class="col-4">{{ candidate.idCard }}</div>
        <div class="col-4">{{ candidate.email }}</div>
      </div>
    </div>
  </div>
</ng-container>

<div class="card mb-4 border-0 shadow-sm">
  <div class="card-body">
    <form [formGroup]="reportGenerateForm" class="col-md-10 col-lg-6 mx-auto" id="reportGenerateForm">
      <div class="form-row">
        <div class="form-group col-12">
          <label for="reportTypeId">{{'REPORTS.REPORTTYPE' | translate}}: *</label>
          <select class="form-control" id="reportTypeId" formControlName="reportTypeId" (ngModelChange)="changeOptionReportType($event); cleanSelectedSkills();">
            <option value="1">{{'REPORTS.REPORTTYPES.PARTICIPANT' | translate}}</option>
            <option value="2">{{'REPORTS.REPORTTYPES.CONSULTANT' | translate}}</option>
            <option value="3">{{'REPORTS.REPORTTYPES.CLIENT' | translate}}</option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="reportGenerateForm.get('reportTypeId').value !== '1' && [1,2].includes(testSelected?.testModelId)">

        <label for="idealProfile">{{'COMMON.JOBTYPEPROFILE' | translate}}:</label>
        <div class="form-row form-group mb-3">
          <div class="col-10">
            <select class="form-control" id="idealProfile" formControlName="idealProfile"
             (ngModelChange)="changeOptionIdealProfile($event)">
             <option disabled value="undefined" *ngIf="!idealProfileSelected">{{ 'REPORTS.SELECTIDEALPROFILE' |translate }}</option>
              <option *ngFor="let idealProfile of idealProfiles"  [ngValue]="idealProfile"
                [ngClass]="{'isUB': idealProfile.isUb}">
                {{ idealProfile.name }}</option>
              </select>
          </div>
          <div class="col-2 text-right">
            <button *ngIf="idealProfileSelected?.jobtype" class="idealProfileButton mr-1" (click)="showViewSkillsModal()" [attr.disabled]="idealProfileSelected ? null : ''">
              <i class="fa fa-eye text-blue" [ngbTooltip]="'TOOLTIP.IDEALPROFILEDETAIL' | translate"></i>
            </button>
            <button class="idealProfileButton" routerLink="/consultant/profiles/create" (click)="utilsService.setLastUrl()">
              <i class="fa fa-plus-circle text-blue" [ngbTooltip]="'TOOLTIP.IDEALPROFILENEW' | translate"></i>
            </button>
          </div>
        </div>
        <div class="form-row form-group mb-3 ml-1" *ngIf="testSelected?.testModelId == 2">
          <input name="onlyProfileSkills" formControlName="onlyProfileSkills" class="idealProfileCheckbox" type="checkbox" (click)="cleanSelectedSkills()" />
          <label class="mb-0" for="idealProfile">{{'REPORTS.SHOWIDEALCOMPETENCES' | translate}}</label>
        </div>
        <div class="form-row form-group mb-3 ml-1">
          <input name="adjustment" formControlName="adjustment" class="idealProfileCheckbox" type="checkbox" (click)="cleanSelectedSkills()" />
          <label class="mb-0" for="idealProfile">{{'REPORTS.IDEALPROFILEADJUST' | translate}}</label>
        </div>
      </ng-container>
      <ng-container *ngIf="HCC.includes(officeId) && testSelected?.testModelId == 2">
        <div class="form-row">
          <div class="form-group col-12">
            <p>
              <button class="selectCompetencesButton" [attr.data_qa]="'selectorCompentencias'"
                (click)="showSelectSkillsModal(); reportGenerateForm.get('onlyProfileSkills').setValue(false); reportGenerateForm.get('adjustment').setValue(false)">
                <span>{{(skillsSelected !== undefined && skillsSelected.length>0)
                  ? ('COMMON.COMPETENCESSELECTED' | translate) : ('COMMON.SELECTCOMPETENCES' | translate) }}
                  {{ (skillsSelected!== undefined && skillsSelected.length>0)  ? skillsSelected.length:''}}</span>
              </button>
              <button  *ngIf="(skillsSelected!== undefined && skillsSelected.length>0)"  class="buttonLikeLink" (click)="closeSelectSkillsModal()">
                {{ 'COMMON.DELETEDCOMPETENCESSELECTED'  | translate}}
               </button>
            </p>
          </div>
        </div>
      </ng-container>

      <div class="form-row">
        <div class="form-group col-12">
          <label for="languageId">{{'COMMON.LANGUAGE' | translate}}: *</label>
          <select class="form-control" id="languageId" formControlName="languageId">
            <option [value]="[5,7].includes(currentConsultant.client.id) ? 1 : currentConsultant.client.id">{{'LANGUAGE.SPANISH' | translate}}</option>
            <option value="7">{{'LANGUAGE.ENGLISH' | translate}}</option>
            <option value="5">{{'LANGUAGE.PORTUGUESE' | translate}}</option>
          </select>
        </div>
      </div>

      <div *ngIf="HCC.includes(officeId)"  class="form-row">
        <div class="form-group col-12">
          <label for="projectId">{{'COMMON.PROJECT' | translate}}:</label>
          <select class="form-control" id="projectId" (change)="setClientAndProject($event)">
            <option [ngValue]="null">{{ 'INVITE.PROJECTNOTSELECTED' | translate }}</option>
            <ng-container *ngFor="let project of projects; let i=index">
              <option *ngFor="let childProject of project.children; let j=index" [value]="[i, j]">
                {{ childProject.name + ' - ' + childProject.description }}
              </option>
            </ng-container>
          </select>
        </div>
      </div>

      <ng-container *ngIf="![1,2].includes(testSelected?.testModelId)">
        <div class="form-row" id="CTreport">
          <div class="form-group col-12">
            <label for="CTreport">{{ 'COMMON.REPORT' | translate }}:</label>
            <button type="submit" form="reportGenerateForm" class="btn btn-primary form-control" (click)="showCTReport()">
              <i class="fa fa-at"></i> {{'REPORTS.SEE&DOWNLOADREPORT' | translate}}
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="[1,2].includes(testSelected?.testModelId)">
        <div class="form-row" id="ADNReport">
          <div [class]="this.testSelected.testModel.id === 2 ? 'col-6' : 'col-12'">
            <div class="form-group">
              <label for="ADNReport">{{'TESTMODELS.COMPETENCES' | translate}}:</label>
              <button type="submit" form="reportGenerateForm" class="btn btn-primary form-control" (click)="showADNReport()" [attr.disabled]="((reportGenerateForm.get('adjustment').value || reportGenerateForm.get('onlyProfileSkills').value)  && !idealProfileSelected) ? '': null">
                <i class="fa fa-at"></i> {{'REPORTS.SEE&DOWNLOADREPORT' | translate}}
              </button>
            </div>
          </div>
          <ng-container *ngIf="this.testSelected.testModel.id === 2">
            <div class="col-6">
              <div class="form-group">
                <label for="MDreport">{{'TESTMODELS.DIGITAL' | translate}}:</label>
                <button type="submit" form="reportGenerateForm" class="btn btn-primary form-control"
                  (click)="showMDReport()"><i class="fa fa-at"></i>
                  {{'REPORTS.SEE&DOWNLOADREPORT' | translate}}</button>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </form>
  </div>
</div>


<ng-template #viewSkillsModal let-modal>
  <div class="modal-header border-bottom-0">
    <h6 class="modal-title">{{ 'COMMON.SHOWCOMPETENCES' | translate }}</h6>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body">
    <h5 class="font-weight-bold">Perfil: {{idealProfileSelected.name}}</h5>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>{{'COMMON.AREA' | translate}}</th>
          <th>{{'COMMON.COMPETENCES' | translate}}</th>
          <th>Min</th>
          <th>Max</th>
        </tr>
      </thead>

      <tbody class="bg-white">
        <tr *ngFor="let questionGroup of idealProfileSelected.jobtype.questionGroups; index as i">
          <td>{{ 'ADNREPORT.SKILLS.TYPES.' + questionGroup.type.toUpperCase() | translate }}</td>
          <td>{{ ('ADNREPORT.SKILLS.' + questionGroup.abbreviation + '.NAME') | translate }} </td>
          <td>{{ idealProfileSelected.adnIdeal[questionGroup.abbreviation.toLowerCase()] }}</td>
          <td>10</td>
        </tr>
    </table>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary"
      (click)="modal.dismiss('cancel click')">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</ng-template>

<ng-template *ngIf="HCC.includes(officeId)" #selectSkillsModal let-modal>

  <div class="modal-header border-bottom-0">
    <h6 class="modal-title">{{ 'COMMON.COMPETENCES' | translate }}</h6>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="closeSelectSkillsModal()">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body">
    <p>{{ 'COMMON.SELECTINFOCOMPETENCES' | translate }}</p>

    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th></th>
          <th>{{'COMMON.AREA' | translate}}</th>
          <th>{{'COMMON.COMPETENCES' | translate}}</th>
        </tr>
      </thead>

      <tbody class="bg-white">
        <tr *ngFor="let skill of listSkills; index as i" (click)="selectSkill(skill)" >
          <ng-container *ngIf="idSkills.includes(skill.id)" >
          <td><input type="checkbox" [checked]="skill.checked" [id]="skill.id"/></td>
          <td>{{ 'ADNREPORT.SKILLS.TYPES.' + skill.type.toUpperCase() | translate }}</td>
          <td>{{ 'ADNREPORT.SKILLS.' + skill.abbreviation + '.NAME' | translate }}</td>
        </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary" (click)="closeSelectSkillsModal()">{{ 'COMMON.CLOSEDANDDELETE' | translate }}</button>
    <button type="button" class="btn btn-primary"(click)="acceptSelectedSkills()">{{ 'COMMON.ACCEPT' | translate }}</button>
  </div>

</ng-template>
